const baseUrl = 'auth';

export const ApiAuth = {
  // gateway-service (BU-20639) - LinkPass authentication; also returns onboardingRequired/
  // bootstrapToken for the B3 onboarding wizard (see redux/app/actions.ts generateAssociation)
  GenerateAssociation: `${baseUrl}/validate`
};
